export const formAgeValidate = (values) => {
  const errors = {}
  if (values.age < 16) {
    errors.ageLimit = true
  }
  return errors
}
